<template>
  <v-navigation-drawer
    v-model="drawer"
    :right="$vuetify.rtl"
    app
    temporary
    style="z-index:995"
  >
    <v-list>
      <v-list-item style="justify-content:center">
        <v-img
          src="@/assets/logo.png"
          contain
          max-height="100px"
          max-width="100px"
          @click="$vuetify.goTo(0)"
        />
      </v-list-item>
      <v-list-item
        to="/"
        :class="txtDir"
      >
        <v-list-item-title style="color:#2e368f">
          {{ $t('HOME') }}
        </v-list-item-title>
      </v-list-item>
      <v-list-item
        v-for="(link, i) in categories"
        :key="i"
        :class="txtDir"
        :to="link.to"
        :href="link.href"
        @click="toProducts(link , 'false' , 'false')"
      >
        <v-list-item-title
          style="color:#2e368f"
          v-text="$root.$t(link.text)"
        />
      </v-list-item>
      <v-list-item>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="#2e368f"
              class="ml-0 px-0"
              text
              style="font-size: 1rem;"
              v-bind="attrs"
              v-on="on"
            >
              {{ $t('new arrivals') }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(item, index) in categories"
              :key="index"
            >
              <v-list-item-title
                style="color:#2e368f;cursor:pointer"
                @click="toProducts(item , 'false' , 'true')"
              >
                {{ $root.$t(item.text.toUpperCase()) }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-list-item>

      <v-list-item>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="#2e368f"
              class="ml-0 px-0"
              text
              style="font-size: 1rem;"
              v-bind="attrs"
              v-on="on"
            >
              {{ $t('special prices') }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(item, index) in categories"
              :key="index"
            >
              <v-list-item-title
                style="color:#2e368f;cursor:pointer"
                @click="toProducts(item , 'true' , 'false')"
              >
                {{ $root.$t(item.text.toUpperCase()) }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-list-item>
      
      <v-list-item
        to="/about"
        :class="txtDir"
      >
        <v-list-item-title style="color:#2e368f">
          {{ $t('ABOUT US') }}
        </v-list-item-title>
      </v-list-item>
      <v-list-item
        to="/contact"
        :class="txtDir"
      >
        <v-list-item-title style="color:#2e368f">
          {{ $t('CONTACT US') }}
        </v-list-item-title>
      </v-list-item>
      <v-list-item
        :class="txtDir"
        @click="changeLang(langChoose)"
      >
        <v-list-item-title style="text-transform:uppercase;color:#2e368f">
          {{ langName }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
// Utilities
  import { mapGetters, mapMutations } from 'vuex'
  import { i18n } from '@/main'
  export default {
    name: 'CoreDrawer',

    computed: {
      ...mapGetters(['categories', 'links']),
      langChoose () {
        return this.$vuetify.rtl ? 'en' : 'ar'
      },
      langName () {
        return this.$vuetify.rtl ? 'English' : 'عربي'
      },
      txtDir () {
        return this.$vuetify.rtl ? 'text-right' : 'text-left'
      },

      drawer: {
        get () {
          return this.$store.state.drawer
        },
        set (val) {
          this.setDrawer(val)
        },
      },
    },
    data: () => ({
      isUserScrolling: false,
      itemsCount: 0,
      searchField: false,
    }),

    methods: {
      ...mapMutations(['toggleDrawer', 'setDrawer']),
      onClick (e, item) {
        e.stopPropagation()
        if (item.to || !item.href) return
        this.$vuetify.goTo(item.href)
      },
      handleScroll (event) {
        this.isUserScrolling = window.scrollY > 0
      },
      toProducts (item, special, arrival) {
        localStorage.setItem('categoryId', item.id)
        localStorage.setItem('special_filter', special)
        localStorage.setItem('arrival_filter', arrival)
        localStorage.removeItem('brandFilter');
        localStorage.removeItem('filterId');
        localStorage.removeItem('filterValue'); 

        var counrty = localStorage.getItem('country') == 'TZ' ? 'Tanzania' : 'Sudan';
        this.$router.push({ path: `/products/${item.text}` }) ///${counrty}
      },
      changeLang (lang) {
        this.$vuetify.rtl = lang === 'ar'
        localStorage.setItem('lang', lang)
        i18n.locale = lang
        const accHead = lang === 'en' ? 'en-us-1' : 'ar-sy-1'
        window.axios.defaults.headers.common['Accept-Language'] = accHead
        window.location.reload()
      },
    },
    created () {
      window.addEventListener('scroll', this.handleScroll)
      this.itemsCount = localStorage.getItem('itemsCount')
      window.addEventListener('itemsCount-localstorage-changed', event => {
        this.itemsCount = event.detail.storage
      })
    },
  }
</script>
